export function getLeagueCountryName(league) {
  return league?.country?.name || "International";
}

const LEAGUE_COUNTRY_PRIORITY = [
  "germany",
  "england",
  "spain",
  "italy",
  "france",
  "europe",
  "austria",
  "switzerland",
  "netherlands",
  "belgium",
  "portugal",
  "scotland",
  "denmark",
  "turkey",
  "sweden",
  "norway",
  "finland",
];

function normalizeLeagueText(value) {
  return String(value || "")
    .trim()
    .toLocaleLowerCase();
}

function getCountryPriority(league) {
  const country = normalizeLeagueText(getLeagueCountryName(league));

  const leagueName = normalizeLeagueText(league?.name);

  /*
   * MLS und Saudi ausdrücklich ans Ende,
   * unabhängig davon, wie Sportmonks das
   * Land exakt benennt.
   */
  if (
    leagueName === "mls" ||
    leagueName.includes("major league soccer") ||
    country.includes("united states") ||
    country === "usa"
  ) {
    return 1001;
  }

  if (country.includes("saudi") || leagueName.includes("saudi")) {
    return 1000;
  }

  const directIndex = LEAGUE_COUNTRY_PRIORITY.findIndex(
    (item) => country === item || country.includes(item)
  );

  if (directIndex >= 0) {
    return directIndex;
  }

  /*
   * Internationale UEFA-Wettbewerbe können
   * je nach Sportmonks-Datensatz als Europe,
   * International o. ä. geführt werden.
   */
  if (
    [
      "champions league",
      "europa league",
      "europa conference league",
      "conference league",
      "uefa super cup",
    ].some((name) => leagueName.includes(name))
  ) {
    return 5;
  }

  return 500;
}

function getLeagueLevelPriority(league) {
  const name = normalizeLeagueText(league?.name);

  const country = normalizeLeagueText(getLeagueCountryName(league));

  /*
   * Europa
   */
  if (name.includes("champions league")) {
    return 1;
  }

  if (name === "europa league" || name.includes("uefa europa league")) {
    return 2;
  }

  if (name.includes("conference league")) {
    return 3;
  }

  if (name.includes("super cup")) {
    return 4;
  }

  /*
   * Deutschland
   */
  if (country.includes("germany")) {
    if (name === "bundesliga") {
      return 1;
    }

    if (name === "2. bundesliga") {
      return 2;
    }

    if (name === "3. liga") {
      return 3;
    }

    if (name.includes("dfb")) {
      return 4;
    }

    if (name.includes("regionalliga")) {
      return 10;
    }
  }

  /*
   * England
   */
  if (country.includes("england")) {
    if (name === "premier league") {
      return 1;
    }

    if (name === "championship") {
      return 2;
    }

    if (name === "league one") {
      return 3;
    }

    if (name === "league two") {
      return 4;
    }

    if (name.includes("national league")) {
      return 5;
    }
  }

  /*
   * Spanien
   */
  if (country.includes("spain")) {
    if (name === "la liga") {
      return 1;
    }

    if (
      name.includes("laliga2") ||
      name.includes("la liga 2") ||
      name.includes("segunda")
    ) {
      return 2;
    }
  }

  /*
   * Italien
   */
  if (country.includes("italy")) {
    if (name === "serie a") {
      return 1;
    }

    if (name === "serie b") {
      return 2;
    }
  }

  /*
   * Frankreich
   */
  if (country.includes("france")) {
    if (name === "ligue 1") {
      return 1;
    }

    if (name === "ligue 2") {
      return 2;
    }
  }

  /*
   * Österreich
   */
  if (country.includes("austria")) {
    if (name.includes("bundesliga")) {
      return 1;
    }

    if (name === "2. liga") {
      return 2;
    }
  }

  /*
   * Niederlande
   */
  if (country.includes("netherlands")) {
    if (name === "eredivisie") {
      return 1;
    }

    if (name.includes("eerste divisie")) {
      return 2;
    }
  }

  /*
   * Portugal
   */
  if (country.includes("portugal") && name.includes("liga portugal")) {
    return 1;
  }

  /*
   * Schottland
   */
  if (country.includes("scotland") && name.includes("premiership")) {
    return 1;
  }

  /*
   * Für übrige Länder:
   * Sportmonks category verwenden, sofern
   * vorhanden. Kleine category = höhere Ebene.
   */
  const category = Number(league?.category);

  if (Number.isFinite(category)) {
    return 100 + category;
  }

  return 500;
}

export function compareLeagueSelection(a, b) {
  const countryPriority = getCountryPriority(a) - getCountryPriority(b);

  if (countryPriority !== 0) {
    return countryPriority;
  }

  const levelPriority = getLeagueLevelPriority(a) - getLeagueLevelPriority(b);

  if (levelPriority !== 0) {
    return levelPriority;
  }

  return String(a?.name || "").localeCompare(String(b?.name || ""));
}
